export const services = [
  {
    slug: "ai-strategy-consulting",
    nav: "AI Strategy & Consulting",
    badge: "Flagship",
    title: "AI Strategy & Executive Advisory",
    image: "/img/ai-strategy.png",
    intro:
      "Board-level AI roadmaps that separate signal from noise. We audit your operations, quantify the opportunity, and deliver an execution plan your leadership can rally behind — in weeks, not quarters.",
    outcome: "A ranked, costed and de-risked AI portfolio your board can approve with confidence.",
    outcomes: [
      "Opportunity audit across every business unit, quantified in dollars",
      "AI readiness assessment: data, talent, systems, governance",
      "Executive roadmap with quick wins and multi-quarter bets",
      "Vendor and model selection guidance — build vs. buy decisions",
      "Risk, compliance and governance framework for enterprise AI",
    ],
    engagements: [
      {
        title: "AI Opportunity Audit",
        detail:
          "Three weeks. We map your processes, interview stakeholders and quantify where AI creates leverage — ending in a board-ready findings deck.",
      },
      {
        title: "Executive AI Roadmap",
        detail:
          "Six weeks. A sequenced portfolio of initiatives with owners, budgets, ROI models and the governance guardrails to execute safely.",
      },
      {
        title: "Fractional Chief AI Officer",
        detail:
          "Ongoing. A senior advisor embedded with your leadership team, keeping strategy, vendors and delivery on track.",
      },
    ],
  },
  {
    slug: "custom-ai-implementation",
    nav: "AI Implementation",
    badge: "Production-ready",
    title: "Custom AI Implementation",
    image: "/img/ai-implementation.png",
    intro:
      "Production LLM agents, RAG pipelines and intelligent automation deployed inside your stack — secure, observable and measurable. We build AI that survives contact with real users.",
    outcome: "Working AI in production — not a proof-of-concept that dies in a slide deck.",
    outcomes: [
      "LLM agents and copilots wired into your real workflows",
      "RAG pipelines over your documents, tickets and knowledge bases",
      "Evaluation and monitoring so quality is measured, not hoped for",
      "Human-in-the-loop design for sensitive decisions",
      "Security, data handling and access controls built in from day one",
    ],
    engagements: [
      {
        title: "AI Agent Build",
        detail:
          "Four to eight weeks. A production agent scoped to one high-value workflow — support, sales ops, research or internal tooling.",
      },
      {
        title: "Enterprise RAG Deployment",
        detail:
          "Ground your AI in your own data: ingestion, retrieval, evaluation and governance across your document estate.",
      },
      {
        title: "Intelligent Process Automation",
        detail:
          "Wire AI into the repetitive core of your operations — triage, extraction, drafting and routing at machine speed.",
      },
    ],
  },
  {
    slug: "custom-development",
    nav: "Custom Development",
    badge: "End-to-end",
    title: "Custom Development",
    image: "/img/custom-dev.png",
    intro:
      "Software that fits, not software you fit into. Full-stack platforms, internal tools and cloud-native architecture built for how you actually work — not how a vendor imagined you might.",
    outcome: "Software your team owns, understands and can extend — without vendor lock-in.",
    outcomes: [
      "Web platforms and customer-facing products built to scale",
      "Internal tools that retire spreadsheets and swivel-chair workflows",
      "Cloud-native architecture: APIs, integrations and data pipelines",
      "Performance, reliability and observability as defaults",
      "Clean handover: documentation, tests and team training included",
    ],
    engagements: [
      {
        title: "Product Build",
        detail:
          "From prototype to production in a single quarter. Weekly demos, tight feedback loops, no surprises at launch.",
      },
      {
        title: "Internal Tooling Sprint",
        detail:
          "Six to ten weeks replacing a painful manual workflow with a purpose-built tool your ops team will actually use.",
      },
      {
        title: "Architecture & Code Review",
        detail:
          "A senior-level audit of your stack: performance bottlenecks, security gaps and the roadmap out of technical debt.",
      },
    ],
  },
  {
    slug: "digital-transformation",
    nav: "Digital Transformation",
    badge: "Enterprise",
    title: "Digital Transformation & Legacy Modernization",
    image: "/img/digital-transformation.png",
    intro:
      "We retire brittle legacy systems without breaking the business. Seamless cloud migration, process automation and data unification — executed alongside your team with zero-downtime discipline.",
    outcome: "Modern systems your business can grow on — without the horror-story migration.",
    outcomes: [
      "Legacy system audits with a clear modernize, migrate or retire call",
      "Phased cloud migration designed for zero downtime",
      "Process automation that removes whole categories of manual work",
      "Data unification: one reliable source of truth across systems",
      "Change management that brings your people along, not just your tech",
    ],
    engagements: [
      {
        title: "Modernization Assessment",
        detail:
          "Three weeks. We map your estate, score every system and produce a phased migration plan with costs and risks made explicit.",
      },
      {
        title: "Migration Program",
        detail:
          "A staged move to modern infrastructure — systems cut over one by one while the business keeps running at full speed.",
      },
      {
        title: "Process Automation Wave",
        detail:
          "Ninety days targeting your most manual departments first, banking measurable hours saved every single month.",
      },
    ],
  },
  {
    slug: "high-roi-marketing",
    nav: "High-ROI Marketing",
    badge: "Growth",
    title: "High-ROI Marketing",
    image: "/img/marketing-growth.png",
    intro:
      "Data-driven acquisition engines where every dollar is tracked to revenue. Performance media, conversion systems and AI-powered attribution that compound month over month.",
    outcome: "Marketing spend you can defend in a board meeting — measured against revenue, not vanity metrics.",
    outcomes: [
      "Full-funnel attribution so you know what actually drives revenue",
      "Performance media managed to a return-on-ad-spend target",
      "Conversion systems: landing pages, funnels and experimentation",
      "AI-powered content and lifecycle campaigns that scale",
      "Weekly reporting against the numbers your CFO cares about",
    ],
    engagements: [
      {
        title: "Growth Engine Build",
        detail:
          "Six weeks to a working acquisition system: tracking, creative, landing pages and media — live and measuring from week one.",
      },
      {
        title: "Conversion Optimization Program",
        detail:
          "Systematic experimentation across your funnel, compounding conversion gains quarter after quarter.",
      },
      {
        title: "AI-Powered Attribution Audit",
        detail:
          "Find out which channels truly drive pipeline — and quietly cut the ones that only look good in reports.",
      },
    ],
  },
];

export const serviceList = services.map((s) => s.title);
